const productionLinks = {
  tradeIn: {
    url: '/trade-in-details/',
  },
  testDrive: {
    url: '/test-drive/',
  },
  contactDealer: {
    url: '/contact-dealer/',
  },
  formsUsedBookATestDrive: {
    en: 'https://www.audi.ca/en/forms/test-drive-uc/',
    fr: 'https://www.audi.ca/fr/forms/test-drive-uc/',
  },
};

export default productionLinks;
